import Footer from '@rentivo/gatsby-theme-barcelona/src/components/navigation/Footer/component';

export default Footer;
